import React from 'react';
import { cn } from '../../utils/cn';
import { CATEGORIES } from '../../config/categoryConfig';

const REPEAT_COUNT = 4;

const lines = Array.from({ length: 8 }, (_, index) => ({
  id: index,
  direction: index % 2 === 0 ? 'left' : 'right',
  topOffset: -12 + index * 16,
  duration: 28 + index * 4,
  delay: index * 2,
}));

function withAlpha(hexColor: string, alpha: number): string {
  if (!hexColor.startsWith('#')) {
    return hexColor;
  }

  let hex = hexColor.slice(1);

  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }

  const value = parseInt(hex, 16);
  const r = (value >> 16) & 255;
  const g = (value >> 8) & 255;
  const b = value & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

const StartBackgroundTicker = React.memo(function StartBackgroundTicker() {
  return (
    <div
      className="start-background-ticker"
      aria-hidden="true"
      style={{ transform: 'translateZ(0)' }}
    >
      {lines.map((line) => (
        <div
          key={line.id}
          className={cn(
            'start-ticker-line',
            line.direction === 'left' ? 'start-ticker-left' : 'start-ticker-right',
            'text-slate-900/20 dark:text-white/15'
          )}
          style={{
            top: `${line.topOffset}%`,
            animationDuration: `${line.duration}s`,
            animationDelay: `-${line.delay}s`,
            animationTimingFunction: 'linear',
          }}
        >
          {Array.from({ length: REPEAT_COUNT }).map((_, index) => {
            const category = CATEGORIES[(index + line.id) % CATEGORIES.length];
            const phraseKey = `ticker-${line.id}-${category.slug}-${index}`;

            return (
              <React.Fragment key={phraseKey}>
                <span className="start-ticker-phrase">
                  <span className="start-ticker-prefix">GUESS THE</span>{' '}
                  <span
                    className="start-ticker-category"
                    style={{ color: withAlpha(category.color, 0.65) }}
                  >
                    {category.displayName.toUpperCase()}
                  </span>{' '}
                  <span className="start-ticker-suffix">STOCK OF THE DAY</span>
                </span>

                {index !== REPEAT_COUNT - 1 && (
                  <span className="start-ticker-separator">•</span>
                )}
              </React.Fragment>
            );
          })}
        </div>
      ))}
    </div>
  );
});

export default StartBackgroundTicker;
